<template>
    <!-- Container para toda la página: ******************************************************* -->
    <v-container fill-height fluid class="events">
        <!-- Layout para toda la página: *********************************************************** -->
        <v-layout align-center justify-center>
            <!-- Flex para la ventana: **************************************************************** -->
            <v-flex xs12 sm11 elevation-6>
                <div class="sub-window">
                    <v-toolbar dense dark color="brown darken-3">
                        <v-toolbar-title>Eventos&nbsp;&nbsp;</v-toolbar-title>    
                        <v-spacer></v-spacer>
                        <v-toolbar-items class="hidden-sm-and-down">
                            <v-btn
                                :disabled="bEdit"
                                text
                                class="text-none"
                                @click="onNewEvent">
                                <v-icon color="white">mdi-folder-plus</v-icon>&nbsp;Nuevo Evento
                            </v-btn>
                            <v-btn
                                :disabled="(bEdit || event.eventoid === 0 )"
                                text
                                class="text-none"
                                @click="onEditEvent">
                                <v-icon color="white">mdi-folder-edit</v-icon>&nbsp;Editar Evento</v-btn>
                            <v-btn
                                :disabled="(bEdit || event.eventoid === 0 )"
                                text
                                class="text-none"
                                @click="onDeleteEvent">
                                <v-icon color="white">mdi-folder-remove</v-icon>&nbsp;Borrar Evento</v-btn>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        :disabled="bEdit"
                                        text
                                        @click="onClose"
                                        v-on="on"
                                    >
                                        <v-icon>mdi-close</v-icon>
                                    </v-btn>
                                </template>
                                <span>Cerrar</span>
                            </v-tooltip>
                        </v-toolbar-items>

                        <!-- Menú lateral para dispositivos con ventanas chicas: -->
                        <v-menu offset-y>
                            <template v-slot:activator="{ on }">
                                <v-btn icon v-on="on" class="hidden-md-and-up">
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-list color="grey lighten-4">
                                <v-list-item :disabled="bEdit" @click="onNewEvent">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-folder-plus</v-icon>&nbsp; Nuevo Usuario
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onEditEvent">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-folder-edit</v-icon>&nbsp; Editar Usuario
                                    </v-list-item-title>
                                </v-list-item>
                                <v-list-item :disabled="bEdit" @click="onDeleteEvent">
                                    <v-list-item-title>
                                        <v-icon color="brown darken-1">mdi-folder-remove</v-icon>&nbsp; Borrar Usuario
                                    </v-list-item-title>
                                </v-list-item>
                                <v-divider></v-divider>
                                <v-list-item :disabled="bEdit" @click="onClose">
                                    <v-list-item-title>
                                        <v-icon color="red">mdi-close</v-icon>&nbsp; Cerrar
                                    </v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </v-toolbar>

                    <!-- Container para lista de eventos y evento seleccionado: -->
                    <v-container pa-2 grid-list-sm fluid>
                        <!-- Renglón único para lista de eventos y card de evento seleccionado: -->
                        <v-layout row wrap justify-space-around>
                            <!-- Lista de eventos: *************************** -->
                            <v-flex xs11 md2>
                                <v-card>
                                    <v-toolbar dense color="brown darken-1" dark flat>
                                        <v-toolbar-title class="my-list-title">Lista de Eventos</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-icon
                                            >mdi-format-list-bulleted</v-icon
                                        >
                                    </v-toolbar>

                                    <v-list
                                        subheader
                                        dense
                                        :height="listHeight"
                                        max-height="100%"
                                        class="overflow-y-auto"
                                        color="grey lighten-4"
                                        :disabled="loadingEvent || bEdit"
                                    >
                                        <v-list-item-group
                                            v-model="selectedEventIndex"
                                            color="orange accent-4"
                                            mandatory
                                        >
                                            <v-list-item
                                                class="my-list-item"
                                                v-for="(event, i) in events"
                                                :key="i"
                                                @click="selectEvent(event.eventoid)">
                                                <v-list-item-content>
                                                    <v-list-item-title>
                                                        <v-container pa-0 fluid>
                                                            <v-layout row wrap>
                                                                <v-flex md2 xs6>
                                                                    {{ event.fechaEvento }}, {{ event.horaInicio }} - {{ event.horaFin }}
                                                                </v-flex>
                                                            </v-layout>
                                                        </v-container>
                                                    </v-list-item-title>
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-list>
                                </v-card>
                            </v-flex>

                            <!-- Termina Lista de Eventos ********************************* -->

                            <!-- Info de Evento seleccionado: *********************** -->
                            <v-flex xs11 md10>
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="brown lighten-3" flat>
                                        <v-icon>mdi-silverware-fork-knife</v-icon>
                                        <v-toolbar-title class="my-list-title"
                                            >&nbsp; {{ selectedEventName }}</v-toolbar-title>
                                    </v-toolbar>

                                    <v-card-text>
                                        <v-container fluid>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12 md9>
                                                    <v-container fluid pl-0>
                                                        <v-layout row wrap justify-space-between>
                                                            <v-flex xs2>
                                                                <v-text-field
                                                                    :dense="bDense"
                                                                    prepend-icon="mdi-counter"
                                                                    name="number"
                                                                    label="Número"
                                                                    type="text"
                                                                    v-model="event.numeroEvento"
                                                                    readonly
                                                                    ref="number_field"
                                                                    color="green darken-3"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs5>
                                                                <v-text-field
                                                                    :dense="bDense"
                                                                    prepend-icon="mdi-calendar-month"
                                                                    name="name"
                                                                    label="Fecha de registro"
                                                                    type="text"
                                                                    v-model="event.fechaRegistro"
                                                                    readonly
                                                                    color="green darken-3"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs5>
                                                                <v-text-field
                                                                    :dense="bDense"
                                                                    prepend-icon="mdi-clipboard-account"
                                                                    name="name"
                                                                    label="Usuario"
                                                                    type="text"
                                                                    v-model="event.usuario"
                                                                    readonly
                                                                    color="green darken-3"
                                                                ></v-text-field>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row wrap justify-space-between>
                                                            <v-flex xs4>
                                                                <v-select
                                                                    :dense="bDense"
                                                                    prepend-icon="mdi-castle"
                                                                    :items="eventRooms"
                                                                    item-text="salon"
                                                                    item-value="salonid"
                                                                    v-model="event.salonid"
                                                                    label="Salón"
                                                                    color="green darken-3"
                                                                    item-color="green darken-3"
                                                                    no-data-text="No hay salones registrados."
                                                                    :readonly="!bEdit">
                                                                </v-select>
                                                            </v-flex>
                                                            <v-flex xs4>
                                                                <v-menu
                                                                    v-model="bMenuDate"
                                                                    :close-on-content-click="false"
                                                                    :nudge-right="40"
                                                                    transition="scale-transition"
                                                                    offset-y
                                                                    min-width="290px"
                                                                    :disabled="!bEdit"
                                                                >
                                                                    <template
                                                                        v-slot:activator="{
                                                                            on,
                                                                        }"
                                                                    >
                                                                        <v-text-field
                                                                            :dense="bDense"
                                                                            color="green darken-3"
                                                                            v-model="event.fechaEvento"
                                                                            label="Fecha del evento"
                                                                            prepend-icon="mdi-calendar-month"
                                                                            readonly
                                                                            v-on="on"
                                                                        ></v-text-field>
                                                                    </template>
                                                                    <v-date-picker
                                                                        color="green darken-3"
                                                                        v-model="event.fechaEvento"
                                                                        @input="bMenuDate = false"
                                                                    ></v-date-picker>
                                                                </v-menu>
                                                            </v-flex>
                                                            <v-flex xs2>
                                                                <v-dialog
                                                                    ref="dialogTimeFrom"
                                                                    v-model="bModalTimeFrom"
                                                                    :return-value.sync="event.horaInicio"
                                                                    persistent
                                                                    width="290px"
                                                                >
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-text-field
                                                                            v-model="event.horaInicio"
                                                                            label="Inicio"
                                                                            prepend-icon="mdi-sort-clock-descending"
                                                                            readonly
                                                                            v-on="on"
                                                                            color="green darken-3"
                                                                        ></v-text-field>
                                                                    </template>
                                                                    <v-time-picker
                                                                        v-if="bModalTimeFrom"
                                                                        v-model="event.horaInicio"
                                                                        color="green darken-3"
                                                                    >
                                                                        <v-spacer></v-spacer>
                                                                        <v-btn
                                                                            text
                                                                            color="green darken-3"
                                                                            class="text-none"
                                                                            @click="$refs.dialogTimeFrom.save(event.horaInicio)"
                                                                        >OK</v-btn>
                                                                        <v-btn
                                                                            text
                                                                            color="pink darken-1"
                                                                            class="text-none"
                                                                            @click="bModalTimeFrom = false"
                                                                        >Cancelar</v-btn>
                                                                    </v-time-picker>
                                                                </v-dialog>
                                                            </v-flex>
                                                            <v-flex xs2>
                                                                <v-dialog
                                                                    ref="dialogTimeTo"
                                                                    v-model="bModalTimeTo"
                                                                    :return-value.sync="event.horaFin"
                                                                    persistent
                                                                    width="290px"
                                                                >
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-text-field
                                                                            v-model="event.horaFin"
                                                                            label="Fin"
                                                                            prepend-icon="mdi-sort-clock-ascending"
                                                                            readonly
                                                                            v-on="on"
                                                                            color="green darken-3"
                                                                        ></v-text-field>
                                                                    </template>
                                                                    <v-time-picker
                                                                        v-if="bModalTimeTo"
                                                                        v-model="event.horaFin"
                                                                        color="green darken-3"
                                                                    >
                                                                        <v-spacer></v-spacer>
                                                                        <v-btn
                                                                            text
                                                                            color="green darken-3"
                                                                            class="text-none"
                                                                            @click="$refs.dialogTimeTo.save(event.horaFin)"
                                                                        >OK</v-btn>
                                                                        <v-btn
                                                                            text
                                                                            color="pink darken-1"
                                                                            class="text-none"
                                                                            @click="bModalTimeTo = false"
                                                                        >Cancelar</v-btn>
                                                                    </v-time-picker>
                                                                </v-dialog>
                                                            </v-flex>
                                                        </v-layout>
                                                        <v-layout row wrap justify-space-between>
                                                            <v-flex xs5 >
                                                                <v-text-field
                                                                    :dense="bDense"
                                                                    prepend-icon="mdi-account"
                                                                    label="Cliente"
                                                                    type="text"
                                                                    v-model="event.cliente"
                                                                    readonly
                                                                    color="green darken-3"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs3>
                                                                <v-text-field
                                                                    :dense="bDense"
                                                                    label="R.F.C."
                                                                    type="text"
                                                                    v-model="event.rfc"
                                                                    readonly
                                                                    color="green darken-3"
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs3>
                                                                <v-btn
                                                                    color="green darken-3"
                                                                    class="text-none"
                                                                    text
                                                                    @click="onClient"
                                                                    :disabled="!bEdit"
                                                                    >Buscar Cliente
                                                                </v-btn>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-container>
                                                </v-flex>
                                                <v-flex xs12 md3>
                                                    <v-textarea
                                                        dense
                                                        outlined
                                                        v-model="event.notas"
                                                        :auto-grow="false"
                                                        no-resize
                                                        color="green darken-3"
                                                        background-color="orange lighten-5"
                                                        label="Notas"
                                                        rows="7"
                                                        :readonly="!bEdit"
                                                    ></v-textarea>
                                                </v-flex>
                                            </v-layout>
                                            
                                            <!-- prepend-icon="mdi-star-box" -->
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12 sm6 md4>
                                                    <v-select
                                                        :dense="bDense"
                                                        prepend-icon="mdi-package-variant"
                                                        :items="eventPackages"
                                                        item-text="paquete"
                                                        item-value="paqueteid"
                                                        v-model="event.paqueteid"
                                                        label="Paquete"
                                                        color="green darken-3"
                                                        item-color="green darken-3"
                                                        :readonly="!bEdit"
                                                    ></v-select>
                                                </v-flex>
                                                
                                                <!-- :value="event.costoPersona | currency" -->
                                                <v-flex xs12 sm6 md3>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        label="Costo por persona"
                                                        prepend-icon="mdi-currency-usd"
                                                        type="number"
                                                        v-model="event.costoPersona"
                                                        @change="onChangeCostoPersona"
                                                        :readonly="!bEdit"
                                                        color="green darken-3"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md3>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        label="Personas"
                                                        type="number"
                                                        v-model="event.numPersonas"
                                                        @change="onChangeNumPersonas"
                                                        :readonly="!bEdit"
                                                        color="green darken-3"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12 sm6 md3>
                                                    <!-- v-model="subtotalPaquete" -->
                                                    <!-- type="number" -->
                                                    <!-- prepend-icon="mdi-currency-usd" -->
                                                    <!-- :value="subtotalPaquete | currency" -->
                                                    <!-- @input="value => subtotalPaquete = value" -->
                                                    <v-text-field
                                                        :dense="bDense"
                                                        label="Subtotal"
                                                        :value="event.subtotalPaquete | currency"
                                                        readonly
                                                        color="green darken-3"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex shrink>
                                                    <v-checkbox
                                                        label="I.V.A."
                                                        v-model="bIvaPaquete"
                                                        :readonly="!bEdit"
                                                        color="green darken-3"
                                                        dense
                                                        @change="onCheckIvaPaquete()"
                                                    ></v-checkbox>
                                                </v-flex>
                                                <v-flex xs9 sm6 md3>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        label="I.V.A."
                                                        :value="event.ivaPaquete | currency"
                                                        readonly
                                                        color="green darken-3"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md3>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        label="Total"
                                                        :value="totalPaquete | currency"
                                                        readonly
                                                        color="green darken-3"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            
                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <v-card class="mx-auto teal--text text--darken-3">
                                                        <v-toolbar height="30" color="brown lighten-3" flat>
                                                            <v-icon mdi-credit-card></v-icon>
                                                            <v-toolbar-title class="my-list-title">&nbsp; Servicios adicionales</v-toolbar-title>
                                                            <v-spacer></v-spacer>

                                                            <v-toolbar-items>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-btn text :disabled="!bEdit" @click="onNuevoServicio" v-on="on">
                                                                            <v-icon>mdi-flag-plus</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Agregar servicio adicional</span>
                                                                </v-tooltip>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-btn text :disabled="!bEdit || selectedService.length === 0" @click="onDeleteService" v-on="on">
                                                                            <v-icon>mdi-flag-minus</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Borrar servicio adicional</span>
                                                                </v-tooltip>
                                                            </v-toolbar-items>
                                                        </v-toolbar>
                                                        <v-data-table
                                                            readonly
                                                            fixed-header
                                                            :headers="servicesHeader"
                                                            :items="event.servicios"
                                                            item-key="servicioid"
                                                            v-model="selectedService"
                                                            locale="es-MX"
                                                            hide-default-footer
                                                            class="elevation-1"
                                                            :show-select = bEdit 
                                                            single-select
                                                            dense
                                                            no-data-text="No hay servicios registrados para este evento."
                                                            :items-per-page="event.servicios.length"
                                                        >
                                                        </v-data-table>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row justify-end>
                                                <v-flex xs2>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        label="Total servicios"
                                                        :value="totalServicios | currency"
                                                        readonly
                                                        color="green darken-3"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>                                                
                                            </v-layout>

                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <v-card class="mx-auto teal--text text--darken-3">
                                                        <v-toolbar height="30" color="brown lighten-3" flat>
                                                        <!-- <v-toolbar height="30" color="green darken-3" dark flat> -->
                                                            <v-icon mdi-credit-card></v-icon>
                                                            <v-toolbar-title class="my-list-title">&nbsp; Pagos</v-toolbar-title>
                                                            <v-spacer></v-spacer>

                                                            <v-toolbar-items>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-btn text :disabled="bEdit" @click="onNewPayment" v-on="on">
                                                                            <v-icon>mdi-credit-card-plus</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Nuevo pago</span>
                                                                </v-tooltip>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-btn text :disabled="bEdit || selectedPayment.length === 0" @click="onEditPayment" v-on="on">
                                                                            <v-icon>mdi-credit-card-edit</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Editar pago</span>
                                                                </v-tooltip>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-btn text :disabled="bEdit || selectedPayment.length === 0" @click="onDeletePayment" v-on="on">
                                                                            <v-icon>mdi-credit-card-remove</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Borrar pago</span>
                                                                </v-tooltip>
                                                                <v-tooltip bottom>
                                                                    <template v-slot:activator="{ on }">
                                                                        <v-btn text :disabled="bEdit || selectedPayment.length === 0" @click="onPrintInvoice" v-on="on">
                                                                            <v-icon>mdi-printer</v-icon>
                                                                        </v-btn>
                                                                    </template>
                                                                    <span>Imprimir</span>
                                                                </v-tooltip>
                                                            </v-toolbar-items>
                                                        </v-toolbar>
                                                        <v-data-table
                                                                readonly
                                                                fixed-header
                                                                :headers="paymentsHeader"
                                                                :items="event.pagos"
                                                                item-key="pagoid"
                                                                v-model="selectedPayment"
                                                                locale="es-MX"
                                                                hide-default-footer
                                                                class="elevation-1"
                                                                show-select
                                                                single-select
                                                                dense
                                                                no-data-text="No hay pagos registrados para este evento."
                                                                :items-per-page="event.pagos.length"
                                                            >
                                                            </v-data-table>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>

                                            <v-layout row wrap justify-end>
                                                <v-flex xs6 md2>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        label="Total evento"
                                                        :value="totalEvento | currency"
                                                        readonly
                                                        color="green darken-3"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs5 md2>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        label="Total pagado"
                                                        :value="pagado | currency"
                                                        readonly
                                                        color="green darken-3"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs5 md2>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        label="Saldo"
                                                        :value="saldo | currency"
                                                        readonly
                                                        color="green darken-3"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <!-- Los siguientes botones de OK y Cancelar se deben mostrar cuando se está registrando o editando un evento:-->
                                            <v-layout v-if=" bEdit" align-center justify-end row fill-height>
                                                <v-flex xs12 sm8 class="text-xs-center text-end">
                                                    <v-btn
                                                        color="green darken-3"
                                                        class="text-none"
                                                        text
                                                        @click="onSave"
                                                    >OK</v-btn
                                                >
                                                    <v-btn
                                                        color="pink darken-1"
                                                        class="text-none"
                                                        text
                                                        @click="onCancel"
                                                        >Cancelar</v-btn
                                                    >
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                            <!-- Termina info de Evento seleccionada *********************** -->
                        </v-layout>

                        <!-- Modal para agregar un servicio adicional: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgNuevoServicio"
                                persistent
                                max-width="80%"
                            >
                                <v-card class="grey lighten-1">
                                    <v-toolbar dense color="green darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title"><v-icon>mdi-flag-plus</v-icon> &nbsp; Agregar servicio adicional &nbsp;</v-toolbar-title>
                                        <v-text-field
                                            hide-details
                                            single-line
                                            v-model="searchServiceText"
                                        ></v-text-field>
                                        <v-btn small icon @click="onSearchServicio"><v-icon>mdi-magnify</v-icon></v-btn>
                                        <v-spacer></v-spacer>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    icon @click="onCancelarNuevoServicio" v-on="on"><v-icon>mdi-close-box</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Cancelar</span>
                                        </v-tooltip>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container pa-2 grid-list-sm fluid>
                                            <v-layout row wrap justify-space-around>
                                                <!-- Lista de servicios adicionales: *************************** -->
                                                <v-flex xs11 md6>
                                                    <v-card>
                                                        <v-toolbar height="30" color="green darken-1" dark flat>
                                                            <v-toolbar-title class="my-list-title">Lista de servicios adicionales</v-toolbar-title>
                                                            <v-spacer></v-spacer>
                                                            <v-icon
                                                                >mdi-format-list-bulleted</v-icon
                                                            >
                                                        </v-toolbar>

                                                        <v-list
                                                            subheader
                                                            dense
                                                            height="100%"
                                                            max-height="482px"
                                                            class="overflow-y-auto"
                                                            color="grey lighten-4"
                                                        >
                                                             
                                                            <v-list-item-group
                                                                color="orange accent-4"
                                                                v-model="selectedServiceIndex"
                                                            >
                                                                <v-list-item
                                                                    class="my-list-item"
                                                                    v-for="(service, i) in services"
                                                                    :key="i"
                                                                    @click="selectService(service.servicioid)"
                                                                    :id="service.servicioid"
                                                                >
                                                                    <v-list-item-content>
                                                                        <v-list-item-title>
                                                                            <v-container pa-0 fluid>
                                                                                <v-layout row>
                                                                                    <v-flex xs12>
                                                                                        {{ service.servicio }}
                                                                                    </v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-list-item-title>
                                                                    </v-list-item-content>
                                                                </v-list-item>
                                                            </v-list-item-group>
                                                        </v-list>
                                                    </v-card>
                                                </v-flex>
                                                <!-- Termina Lista de Servicios Adicionales ********************************* -->

                                                <!-- Info de Servicio Adicional Seleccionado: *********************** -->
                                                <v-flex xs11 md6>
                                                    <v-card class="grey lighten-4">
                                                        <v-toolbar height="30" color="green lighten-3" flat>
                                                            <v-icon>mdi-flag</v-icon>
                                                            <v-toolbar-title class="my-list-title"
                                                                >&nbsp; Servicio a Agregar:</v-toolbar-title>
                                                            </v-toolbar>

                                                            <v-card-text>
                                                                <v-container fluid>
                                                                    <v-layout row wrap justify-space-between>
                                                                        <v-flex xs12>
                                                                            <v-container fluid pl-0>
                                                                                <v-layout row>
                                                                                    <v-flex xs12>
                                                                                        <v-textarea
                                                                                            label=""
                                                                                            outlined
                                                                                            v-model="selectedServiceName"
                                                                                            color="green darken-3"
                                                                                            background-color="green lighten-5"
                                                                                            :auto-grow="false"
                                                                                            no-resize
                                                                                            readonly
                                                                                        ></v-textarea>
                                                                                    </v-flex>
                                                                                </v-layout>
                                                                                <v-layout row justify-end>
                                                                                    <v-flex xs3>
                                                                                        <v-text-field
                                                                                            :dense="bDense"
                                                                                            reverse
                                                                                            prepend-icon="mdi-currency-usd"
                                                                                            label="Costo"
                                                                                            type="number"
                                                                                            v-model="costoServicio"
                                                                                            @change="onChangeCostoServicio"
                                                                                            color="green darken-3"
                                                                                            :disabled="selectedServiceID === 0"
                                                                                        ></v-text-field>
                                                                                    </v-flex>
                                                                                    <v-flex xs2 offset-xs1>
                                                                                        <v-text-field
                                                                                            :dense="bDense"
                                                                                            label="Cantidad"
                                                                                            type="number"
                                                                                            v-model="cantidadServicio"
                                                                                            @change="onChangeCostoServicio"
                                                                                            color="green darken-3"
                                                                                            :disabled="selectedServiceID === 0"
                                                                                            reverse
                                                                                        ></v-text-field>
                                                                                    </v-flex>
                                                                                    <v-flex xs3 offset-xs1>
                                                                                        <v-text-field
                                                                                            reverse
                                                                                            :dense="bDense"
                                                                                            label="Subtotal"
                                                                                            v-model="subtotalServicio"
                                                                                            color="green darken-3"
                                                                                            readonly
                                                                                        ></v-text-field>
                                                                                    </v-flex>
                                                                                </v-layout>
                                                                                <v-layout row justify-end>
                                                                                    <v-flex shrink>
                                                                                        <v-checkbox
                                                                                            label="I.V.A."
                                                                                            v-model="bIvaServicio"
                                                                                            color="green darken-3"
                                                                                            dense
                                                                                            @change="onCheckIvaServicio()"
                                                                                        ></v-checkbox>
                                                                                    </v-flex>
                                                                                    <v-flex xs3>
                                                                                        <v-text-field
                                                                                            :dense="bDense"
                                                                                            reverse
                                                                                            readonly
                                                                                            label="I.V.A."
                                                                                            :value="ivaServicio | currency"
                                                                                            color="green darken-3"
                                                                                        ></v-text-field>
                                                                                    </v-flex>
                                                                                </v-layout>
                                                                                <v-layout row justify-end>
                                                                                    <v-flex xs3>
                                                                                        <v-text-field
                                                                                            :dense="bDense"
                                                                                            reverse
                                                                                            readonly
                                                                                            label="Total"
                                                                                            :value="totalServicio | currency"
                                                                                            color="green darken-3"
                                                                                        ></v-text-field>
                                                                                    </v-flex>
                                                                                </v-layout>
                                                                            </v-container>
                                                                        </v-flex>
                                                                    </v-layout>
                                                                </v-container>
                                                            </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                                <!-- Termina Info de Servicio Adicional Seleccionado: *********************** -->
                                            </v-layout>
                                            <!-- Modal para informar que no hubo resultados en la búsqueda de un servicio adicional: *********************************** -->
                                            <v-layout row justify-center>
                                                <v-dialog
                                                    v-model="bShowExtraNotFoundAlert"
                                                    persistent
                                                    max-width="30%"
                                                >
                                                    <v-card class="grey lighten-4">
                                                        <v-toolbar dense color="orange darken-4" dark flat>
                                                            <v-toolbar-title class="my-list-title"
                                                                >Búsqueda de servicios</v-toolbar-title
                                                            >
                                                            <v-spacer></v-spacer>
                                                            <v-icon>mdi-magnify</v-icon>
                                                        </v-toolbar>
                                                        <v-card-text>
                                                            <v-container>
                                                                <v-layout row>
                                                                    <v-flex xs12 class="d-flex justify-center">
                                                                        <v-icon
                                                                            large
                                                                            color="orange darken-2"
                                                                            >mdi-alert</v-icon
                                                                        >
                                                                    </v-flex>
                                                                </v-layout>
                                                                <v-layout row>
                                                                    <v-flex
                                                                        xs12
                                                                        class="d-flex justify-center"
                                                                        >No hay servicios registrados con ese nombre.</v-flex
                                                                    >
                                                                </v-layout>
                                                            </v-container>
                                                        </v-card-text>

                                                        <v-card-actions>
                                                            <v-spacer></v-spacer>
                                                            <v-btn
                                                                color="teal darken-3"
                                                                class="text-none"
                                                                text
                                                                @click="bShowExtraNotFoundAlert = false"
                                                                >OK</v-btn
                                                            >
                                                        </v-card-actions>
                                                    </v-card>
                                                </v-dialog>
                                            </v-layout>
                                            <!-- Termina modal para informar que no hubo resultados en la búsqueda de un servicio adicional*************************** -->
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmarNuevoServicio"
                                            :disabled="selectedServiceID===0"
                                            >OK</v-btn
                                        >

                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelarNuevoServicio"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para agregar un servicio adicional ********************************************-->

                        <!-- Modal para confirmar borrado de servicio adicional: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bBorrandoServicio"
                                persistent
                                max-width="35%"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar
                                        dense
                                        color="orange darken-4"
                                        dark
                                        flat
                                    >
                                        <v-toolbar-title class="my-list-title"
                                            >Borrar servicio adicional</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-delete</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon
                                                large
                                                color="orange darken-2"
                                                >mdi-alert</v-icon
                                            >
                                        </div>
                                        &nbsp; ¿Desea borrar el servicio "{{ servicioABorrrar }}"?
                                    </v-card-title>
                                    
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="confirmDeleteService"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteService"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de servicio adicional *************************** -->

                        <!-- Modal para agregar o editar un pago: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDlgPayment"
                                persistent
                                max-width="60%"
                            >
                                <v-card class="grey lighten-3">
                                    <v-toolbar dense color="green darken-3" dark flat>
                                        <v-toolbar-title v-if="bNewPayment" class="my-list-title"><v-icon>mdi-credit-card-plus</v-icon> &nbsp; Nuevo pago &nbsp;</v-toolbar-title>
                                        <v-toolbar-title v-else class="my-list-title"><v-icon>mdi-credit-card-edit</v-icon> &nbsp; Edición de pago &nbsp;</v-toolbar-title>
                                        <v-spacer></v-spacer>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    icon @click="onCancelPayment" v-on="on"><v-icon>mdi-close-box</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Cancelar</span>
                                        </v-tooltip>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container pa-2 grid-list-sm fluid>
                                            <v-layout row>
                                                <v-flex xs12 sm6 md3>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-counter"
                                                        label="Folio"
                                                        readonly
                                                        v-model="folioPago"           
                                                        color="green darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 sm6 md4>
                                                    <v-menu
                                                        v-model="bMenuPaymentDate"
                                                        :close-on-content-click="false"
                                                        :nudge-right="40"
                                                        transition="scale-transition"
                                                        offset-y
                                                        min-width="290px"
                                                    >
                                                        <template
                                                            v-slot:activator="{
                                                                 on,
                                                            }"
                                                         >
                                                            <v-text-field
                                                                :dense="bDense"
                                                                color="green darken-3"
                                                                v-model="fechaPago"
                                                                label="Fecha"
                                                                prepend-icon="mdi-calendar-month"
                                                                readonly
                                                                v-on="on"
                                                            ></v-text-field>
                                                        </template>
                                                        <v-date-picker
                                                            color="green darken-3"
                                                            v-model="fechaPago"
                                                            @input="bMenuPaymentDate = false"
                                                        ></v-date-picker>
                                                    </v-menu>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap justify-space-between>
                                                <v-flex xs12>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-barcode"
                                                        label="Concepto"
                                                        v-model="conceptoPago"
                                                        color="green darken-3"
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex xs12 sm8 md4>
                                                    <v-select
                                                        :dense="bDense"
                                                        prepend-icon="mdi-credit-card"
                                                        :items="formasDePago"
                                                        item-text="formaPago"
                                                        item-value="formaPagoID"
                                                        v-model="formaPagoID"
                                                        label="Forma de pago"
                                                        color="green darken-3"
                                                        item-color="green darken-3"
                                                        no-data-text="No hay formas de pago registradas."
                                                    >
                                                    </v-select>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-space-between>
                                                <v-flex xs12 md3>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        prepend-icon="mdi-currency-usd"
                                                        label="Subtotal"
                                                        v-model="subtotalPago"
                                                        @change="onChangeSubtotalPago"
                                                        color="green darken-3"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex shrink>
                                                    <v-checkbox
                                                        label="I.V.A."
                                                        v-model="bIvaPago"
                                                        color="green darken-3"
                                                        dense
                                                        @change="onCheckIvaPago()"
                                                    ></v-checkbox>
                                                </v-flex>
                                                <v-flex xs7 md3>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        readonly
                                                        label="I.V.A."
                                                        :value="ivaPago | currency"
                                                        color="green darken-3"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                                <v-flex xs12 md3>
                                                    <v-text-field
                                                        :dense="bDense"
                                                        readonly
                                                        label="Total"
                                                        :value="totalPago | currency"
                                                        color="green darken-3"
                                                        reverse
                                                    ></v-text-field>
                                                </v-flex>
                                            </v-layout>  
                                        </v-container>
                                    </v-card-text>
                                    

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onSavePayment"
                                            >OK</v-btn
                                        >

                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelPayment"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para agregar o editar un pago ********************************************-->

                        <!-- Modal para pedir que se introduzcan todos los campos de un pago: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bInvalidPaymentData"
                                persistent
                                :width="errorModalWidth"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Información de pago incompleta</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon
                                            >mdi-credit-card-plus</v-icon
                                        >
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                        >mdi-alert-circle</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs11
                                                    class="justify-center text-center"
                                                    >{{ errorMessage }}</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidPaymentData = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introduzcan todos los campos de un pago*********************************** -->

                        <!-- Modal para confirmar borrado de pago: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bBorrandoPago"
                                persistent
                                max-width="35%"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar
                                        dense
                                        color="orange darken-4"
                                        dark
                                        flat
                                    >
                                        <v-toolbar-title class="my-list-title"
                                            >Borrar pago</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-credit-card-remove</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon
                                                large
                                                color="orange darken-2"
                                                >mdi-alert</v-icon
                                            >
                                        </div>
                                        &nbsp; {{ pagoABorrar }}
                                    </v-card-title>
                                     <v-card-text class="text-center" >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="confirmDeletePayment"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeletePayment"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de pago *************************** -->

                        <!-- Modal para pedir que se introduzcan todos los campos obligatorios de un evento: *********************************** -->
                        <v-layout row justify-center>
                            <v-dialog v-model="bInvalidEventData" persistent :width="errorModalWidth">
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="orange darken-4" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Información de evento incompleta</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon
                                            >mdi-silverware-fork-knife</v-icon
                                        >
                                    </v-toolbar>
                                    <v-card-title>
                                        <v-container>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                >
                                                    <v-icon
                                                        large
                                                        color="orange darken-2"
                                                        >mdi-alert-circle</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row justify-center>
                                                <v-flex
                                                    xs11
                                                    class="justify-center text-center"
                                                    >{{ errorMessage }}</v-flex
                                                >
                                            </v-layout>
                                        </v-container>
                                    </v-card-title>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="bInvalidEventData = false"
                                            >OK</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina modal para pedir que se introduzcan todos los campos de un evento*********************************** -->

                        <!-- Modal para confirmar borrado de pago: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bDeletingEvent"
                                persistent
                                max-width="35%"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar
                                        dense
                                        color="orange darken-4"
                                        dark
                                        flat
                                    >
                                        <v-toolbar-title class="my-list-title"
                                            >Borrar evento</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-folder-remove</v-icon>
                                    </v-toolbar>
                                    <v-card-title class="text-center">
                                        <div style="margin: auto">
                                            <v-icon
                                                large
                                                color="orange darken-2"
                                                >mdi-alert</v-icon
                                            >
                                        </div>
                                        &nbsp; ¿Está seguro de querer borrar este evento?
                                    </v-card-title>
                                     <v-card-text class="text-center" >Esta acción no se puede deshacer.</v-card-text>
                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="deleteEventConfirmed"
                                            >OK</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="cancelDeleteEvent"
                                            >Cancelar</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar borrado de evento *************************** -->

                        <!-- Modal para para confirmar impresión de recibo de pago: **************************************** -->
                        <v-layout row justify-center>
                            <v-dialog
                                v-model="bPrintInvoiceDlg"
                                persistent
                                max-width="35%"
                            >
                                <v-card class="grey lighten-4">
                                    <v-toolbar dense color="green darken-3" dark flat>
                                        <v-toolbar-title class="my-list-title"
                                            >Imprimir recibo</v-toolbar-title
                                        >
                                        <v-spacer></v-spacer>
                                        <v-icon>mdi-receipt</v-icon>
                                    </v-toolbar>
                                    <v-card-text>
                                        <v-container fluid>
                                            <v-layout row>
                                                <v-flex xs12 class="d-flex justify-center">
                                                    <v-icon
                                                        x-large
                                                        color="gray darken-3"
                                                        >mdi-printer</v-icon
                                                    >
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row>
                                                <v-flex
                                                    xs12
                                                    class="d-flex justify-center"
                                                    >¿Desea imprimir el recibo del pago seleccionado?
                                                </v-flex>
                                            </v-layout>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            color="teal darken-3"
                                            class="text-none"
                                            text
                                            @click="onConfirmPrintInvoice"
                                            >Sí</v-btn
                                        >
                                        <v-btn
                                            color="pink darken-1"
                                            class="text-none"
                                            text
                                            @click="onCancelPrintInvoice"
                                            >No</v-btn
                                        >
                                    </v-card-actions>
                                </v-card>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para confirmar impresión de recibo *************************** -->

                        <!-- Modal para para buscar al cliente: **************************************** -->
                        <v-layout v-if ="showClientsDlg" row justify-center>
                            <v-dialog
                                v-model="showClientsDlg"
                                persistent
                                :width="clientsModalWidth"
                            >
                                <clients :id="event.clienteid ":rfc="event.rfc" :cliente="event.cliente"></clients>
                            </v-dialog>
                        </v-layout>
                        <!-- Termina Modal para buscar al cliente *************************** -->

                        <!-- Termina renglón único para lista de eventos y evento seleccionado -->
                    </v-container>
                    <!-- Termina container para lista de eventos y evento seleccionado -->
                </div>
            </v-flex>
            <!-- Fin Flex para la ventana **************************************************************** -->
        </v-layout>
        <!-- Fin Layout para toda la página *********************************************************** -->
        <v-overlay :value="waitCursor">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
    </v-container>
    <!-- Fin container para toda la página ********************************************* -->
</template>
<script>
import { mapGetters } from 'vuex';
import Vue from 'vue';
import Vue2Filters from 'vue2-filters';
import Clients from '../components/Clients.vue';

Vue.use(Vue2Filters)

export default {
    name: 'events',
    data() {
        return {
            bDense: false,
            drawer: false,
            bEdit: false,
            bNew: false,
            bInvalidEventData: false,
            bInvalidPaymentData: false,
            errorMessage: '',

            searchServiceText: '',
            selectedServiceName: '',
            selectedServiceIndex: -1,
            selectedServiceID: -1,
            bShowExtraNotFoundAlert: false,

            bIvaPaquete: false,

            costoServicio: 0,
            cantidadServicio: 0,
            subtotalServicio: 0,
            ivaServicio: 0,
            bIvaServicio: false,
            totalServicio: 0,
            bBorrandoServicio: false,
            servicioABorrrar: '',

            bBorrandoPago: false,
            pagoABorrar: '',
            selectedEventName: '',
            
            bMenuDate: false,
            bModalTimeFrom: false,
            bModalTimeTo: false,
            bMenuPaymentDate: false,

            bDeletingEvent: false,

            servicesHeader: [
                {
                    text: 'Concepto',
                    sortable: true,
                    align: 'left',
                    value: 'concepto',
                },
                {
                    text: 'Costo Unitario',
                    sortable: true,
                    align: 'right',
                    value: 'costo',
                },
                {
                    text: 'Cantidad',
                    sortable: true,
                    align: 'right',
                    value: 'cantidad',
                },
                {
                    text: 'Subtotal',
                    sortable: true,
                    align: 'right',
                    value: 'subtotal'
                },
                {
                    text: 'IVA',
                    sortable: true,
                    align: 'right',
                    value: 'iva'
                },
                {
                    text: 'Total',
                    sortable: true,
                    align: 'right',
                    value: 'total'
                }
            ],
            
            paymentsHeader: [
                {
                    text: 'Folio',
                    sortable: true,
                    align: 'right',
                    value: 'folio',
                },
                {
                    text: 'Fecha',
                    sortable: true,
                    align: 'center',
                    value: 'fecha',
                },
                {
                    text: 'Concepto',
                    sortable: true,
                    align: 'left',
                    value: 'concepto'
                },
                {
                    text: 'Forma de pago',
                    sortable: true,
                    align: 'left',
                    value: 'formaPago'
                },
                {
                    text: 'Subtotal',
                    sortable: true,
                    align: 'right',
                    value: 'subtotal'
                },
                {
                    text: 'IVA',
                    sortable: true,
                    align: 'right',
                    value: 'iva'
                },
                {
                    text: 'Total',
                    sortable: true,
                    align: 'right',
                    value: 'total'
                }
            ],
            selectedPayment: [],
            selectedService: [],

            bDlgNuevoServicio: false,
            bDlgPayment: false,
            bNewPayment: false,
            //strPagoTitulo: '', //Título para el modal del pago (nuevo pago o edición de pago).

            pagoID: 0,
            folioPago: 0,
            fechaPago: '',
            conceptoPago: '',
            formaPagoID: 0,
            formaPago: '',
            subtotalPago: 0,
            bIvaPago: false,
            ivaPago: 0,
            totalPago: 0,
            
            formasDePago: [
                {
                    formaPagoID: 1,
                    formaPago: 'Cheque'
                },
                {
                    formaPagoID: 2,
                    formaPago: 'Efectivo'
                },
                {
                    formaPagoID: 3,
                    formaPago: 'Tarjeta de crédito'
                },
                {
                    formaPagoID: 4,
                    formaPago: 'Tarjeta de débito'
                },
                {
                    formaPagoID: 5,
                    formaPago: 'Transferencia'
                },
                 {
                    formaPagoID: 6,
                    formaPago: 'Depósito'
                },
            ],

            bPrintInvoiceDlg: false,
            
        };
    },

    components: {
        Clients
    },

    created() {

        this.selectFirstEvent();
    },
    methods: {
        onClose() {
            this.$router.push('/');
        },
        
        selectFirstEvent() {
            console.log('selectFirstEvent, this.events =, ', this.events);
            if (this.events.length > 0)
            {
                this.selectedEventIndex = 0;
                var eventoid = this.events[this.selectedEventIndex].eventoid;
                this.selectEvent(eventoid);
            }
            else
            {
                this.selectedEventIndex = -1;
            }
        },

        selectEvent(eventoid) {
            this.loadingEvent = true; //Para no dejar seleccionar otro evento antes de que se haya terminado de cargar toda la información.
            this.$store.dispatch('getEventData', eventoid);
            this.selectedPayment = [];
        },

        selectService(servicioid)
        {
            var i;
            for (i = 0; i < this.services.length; i ++)
            {
                if (this.services[i].servicioid === servicioid)
                {
                    this.selectedServiceID = this.services[i].servicioid;
                    this.selectedServiceName = this.services[i].servicio;
                    this.subtotalServicio = 0;
                    this.onChangeCostoServicio();
                    break;
                }
            }
        },

        getEventLocalData()
        {
            // this.eventoid = this.event.eventoid;
            // this.numeroEvento = this.event.numeroEvento;
            // this.fechaRegistro = this.event.fechaRegistro;
            // this.usuarioid = this.event.usuarioid;
            // this.usuario = this.event.usuario;
            // this.notas = this.event.notas;
            // this.salonid = this.event.salonid;
            // this.fechaEvento = this.event.fechaEvento;
            // this.horaInicio = this.event.horaInicio;
            // this.horaFin = this.event.horaFin;
            // this.cliente = this.event.cliente;
            // this.rfc = this.event.rfc;
            // this.paqueteid = this.event.paqueteid;
            // this.costoPersona = this.event.costoPersona;
            // this.numPersonas = this.event.numPersonas;
            // this.subtotalPaquete = this.event.subtotalPaquete;
            // this.ivaPaquete = this.event.ivaPaquete;
            // this.totalPaquete = this.event.totalPaquete;
            // this.totalServicios = this.event.totalServicios;
            // this.totalEvento = this.event.totalEvento;
            // this.pagado = this.event.pagado;
            // this.adeudo = this.event.adeudo;

            this.selectedEventName = this.event.fechaEvento + ', ' + this.event.horaInicio + '-' + this.event.horaFin;
            if (this.event.ivaPaquete !== 0)
            {
                this.bIvaPaquete = true;
            }
            else
            {
                this.bIvaPaquete = false;
            }
        },

        onNewEvent() {
            this.selectedEventName = "Nuevo Evento";
            this.selectedEventIndex = -1;

            this.event.eventoid = 0;
            this.event.numeroEvento = 0;

            const fechaRegistro = new Date();

            this.event.fechaRegistro = this.formatDate(fechaRegistro);
            this.event.usuarioid = this.loggedUserID;
            this.noClientSearchResult = "Teclee el nombre y/o R.F.C. del cliente a buscar";

            //Obtiene el nombre del usuario logueado:
            var i;
            for (i = 0; i < this.users.length; i ++)
            {
                if (this.loggedUserID === this.users[i].usuarioid)
                {
                    this.event.usuario = this.users[i].nombre + ' ' + this.users[i].appaterno;
                    if (this.users[i].apmaterno !== '')
                    {
                        this.event.usuario += ' ' + this.users[i].apmaterno;
                    }
                    break;
                }
            }

            this.event.notas = '';
            this.event.salonid = 0;
            //this.event.fechaEvento = '';
            this.event.fechaEvento = this.formatDate(fechaRegistro);
            this.event.horaInicio = '';
            this.event.horaFin = '';
            this.event.clienteid = 0;
            this.event.cliente = '';
            this.event.rfc = '';
            this.event.paqueteid = 0;
            this.event.costoPersona = 0;
            this.event.numPersonas = 0;
            this.event.subtotalPaquete = 0;
            this.event.ivaPaquete = 0;
            this.bIvaPaquete = false;
            //this.event.totalPaquete = 0;
            //this.event.totalServicios = 0;
            //this.event.totalEvento = 0;
            //this.event.pagado = 0;
            //this.event.adeudo = 0;
            this.event.pagos = [];
            this.event.servicios = [];

            this.bEdit = true;
            this.bNew = true;
        },

        onEditEvent() {
            this.bEdit = true;
        },

        onSave() {
            var bDataOK = false;

            console.log("Event to save = ", this.event);

            //Validación de datos:
            if (this.event.salonid === 0)
            {
                this.bInvalidEventData = true;
                this.errorMessage = "Seleccione un salón.";
            }
            else
            if (this.event.fechaEvento === '')
            {
                this.bInvalidEventData = true;
                this.errorMessage = "Seleccione una fecha para el evento.";
            }
            else
            if (this.event.horaInicio === '')
            {
                this.bInvalidEventData = true;
                this.errorMessage = "Seleccione una hora para el evento.";
            }
            else
            if (this.event.horaFin === '')
            {
                this.bInvalidEventData = true;
                this.errorMessage = "Seleccione una hora para la terminación del evento.";
            }
            else
            if (this.event.clienteid === 0)
            {
                this.bInvalidEventData = true;
                this.errorMessage = "Seleccione al cliente.";
            }
            else
            if (this.event.paqueteid === 0)
            {
                this.bInvalidEventData = true;
                this.errorMessage = "Seleccione un paquete.";
            }
            else
            if (this.event.costoPersona === 0)
            {
                this.bInvalidEventData = true;
                this.errorMessage = "Ingrese el costo por persona.";
            }
            else
            if (this.event.numPersonas === 0)
            {
                this.bInvalidEventData = true;
                this.errorMessage = "Ingrese el número de personas que asistirán al evento";
            }
            else
            {
                bDataOK = true;
            }

            if (!this.bNew && bDataOK)
            {
                //Edición de evento...
                this.$store.dispatch('editEvent', this.event);
            }
            else if (this.bNew && bDataOK)
            {
                //Registro de nuevo evento...
                this.$store.dispatch('saveNewEvent', this.event);
            }

            if (bDataOK)
            {
                this.selectedEventName = this.event.fechaEvento + ', ' + this.event.horaInicio + '-' + this.event.horaFin;
                this.bNew = false;
                this.bEdit = false;
            }
        },
        onCancel(){
            if (this.bNew)
            {
                //console.log("Cancelando selectFirstEvent en onCancel...");
                this.selectFirstEvent();
                this.bNew = false;
            }
            else
            {
                this.$store.dispatch('fetchEvents');
                this.selectEvent(this.event.eventoid);
            }
            this.selectedService = [];
            this.bEdit = false;
        },

        onDeleteEvent() {
            this.bDeletingEvent = true;
        },

        cancelDeleteEvent() {
            this.bDeletingEvent = false;
        },

        deleteEventConfirmed()
        {
            this.bDeletingEvent = false;

            //Como el borrado en el servidor es asíncrono, antes de borrar el registro en el servidor se borra
            //el registro localmente. Si no, si el registro borrado era el primer registro, si primero se
            //borra en el servidor y después se selecciona el primer registro, es posible que se vuelva a
            //seleccionar el registro borrado antes de que éste se borre en el servidor.

            var i;
            for (i = 0; i < this.events.length; i++) {
                if (this.events[i].eventoid === this.event.eventoid) {
                    this.events.splice(i, 1);
                    break;
                }
            }

            this.$store.dispatch('deleteEvent', this.event.eventoid);
            this.selectFirstEvent();
        },

        onClient(){
            this.showClientsDlg = true;
        },

        onPrintInvoice(){
            this.bPrintInvoiceDlg = true;
        },

        onCancelPrintInvoice()
        {
            this.bPrintInvoiceDlg = false;
        },

        onConfirmPrintInvoice(){
            this.$store.dispatch('printPayment', this.selectedPayment[0].pagoid);
            this.bPrintInvoiceDlg = false;
        },

        onNewPayment(){
            this.pagoID = 0;
            const d = new Date();
            this.fechaPago = this.formatDate(d);
            this.folioPago = 0;
            this.conceptoPago = '';
            this.formaPagoID = 0;
            this.subtotalPago = 0;
            this.bIvaPago = false;
            this.ivaPago = 0;
            this.totalPago = 0;

            this.bNewPayment = true;
            //this.strPagoTitulo = "Nuevo pago";
            this.bDlgPayment = true;
        },
        formatDate(date)
        {
            var month = '' + (date.getMonth() + 1);
            var day = '' + date.getDate();
            var year = date.getFullYear();

            //console.log("month = ", month);
            //console.log("day = ", day);

            if (month.length < 2)
            {
                month = '0' + month;
            }
            if (day.length < 2)
            {
                day = '0' + day;
            }

            //console.log("month = ", month);
            //console.log("day = ", day);
            return [year, month, day].join('-');
        },
        onCancelPayment(){
            this.bNewPayment = false;
            this.bDlgPayment = false;
        },
        onEditPayment(){
            //console.log("this.selectedPayment[0] = ", this.selectedPayment[0]);
            this.pagoID = this.selectedPayment[0].pagoid;
            this.fechaPago = this.selectedPayment[0].fecha;
            this.folioPago = this.selectedPayment[0].folio;
            this.conceptoPago = this.selectedPayment[0].concepto;
            this.formaPagoID = this.selectedPayment[0].formaPagoid;
            this.subtotalPago = this.selectedPayment[0].subtotal;
            if (this.selectedPayment[0].iva === 0)
            {
                this.bIvaPago = false;
                this.ivaPago = 0;
            }
            else
            {
                this.bIvaPago = true;
                this.ivaPago = this.selectedPayment[0].iva;
            } 
            this.totalPago = this.selectedPayment[0].total;

            this.bNewPayment = false;
            this.bDlgPayment = true;
        },

        onSavePayment()
        {
            var bDataOK = false;

            //Validación de los datos:

            this.subtotalPago = Number(this.subtotalPago);
            console.log("subtotalPago = ", this.subtotalPago);
           
            if (this.conceptoPago === "")
            {
                this.bInvalidPaymentData = true;
                this.errorMessage = "Teclee el concepto del pago."
            }
            else
            if (this.formaPagoID === 0)
            {
                this.bInvalidPaymentData = true;
                this.errorMessage = "Seleccione la forma de pago."
            }
            else
            if (isNaN(this.subtotalPago))
            {
                this.bInvalidPaymentData = true;
                this.subtotalPago = 0;
                this.errorMessage = "Introduzca un monto de pago correcto."
            }
            else
            if (this.subtotalPago === 0)
            {
                this.bInvalidPaymentData = true;
                this.errorMessage = "Introduzca el monto del pago."
            }
            else{
                bDataOK = true;
            }

            if (bDataOK)
            {
                this.bNewPayment = false;
                this.bDlgPayment = false;

                //Encuentra el string de la forma de pago:
                console.log("formasDePago = ", this.formasDePago);
                console.log("formaPagoID = ", this.formaPagoID);
                var i;
                for (i = 0; i < this.formasDePago.length; i ++)
                {
                    if (this.formasDePago[i].formaPagoID === this.formaPagoID)
                    {
                        this.formaPago = this.formasDePago[i].formaPago;
                        break;
                    }
                }

                var pago = {
                    pagoid: this.pagoID,
                    eventoid: this.event.eventoid,
                    folio: this.folioPago,
                    fecha: this.fechaPago,
                    concepto: this.conceptoPago,
                    formaPagoid: this.formaPagoID,
                    formaPago: this.formaPago,
                    subtotal: this.subtotalPago,
                    iva: this.ivaPago,
                    total: this.totalPago
                }

                var paymentInfo = {
                    eventoID: this.event.eventoid,
                    pago: pago
                }

                this.$store.dispatch('savePayment', paymentInfo);

                this.selectedPayment = [];
                
            }
        },
        
        onDeletePayment(){
            //console.log("A ver, this.selectedPayment[0] = ", this.selectedPayment[0]);
            this.pagoABorrar = "¿Desea borrar el pago de " + this.selectedPayment[0].concepto + " por concepto de " +
                                // this.selectedPayment[0].total  + "?";
                                this.$options.filters.currency(this.selectedPayment[0].total)  + "?";
            this.bBorrandoPago = true;
        },

        cancelDeletePayment(){
            this.bBorrandoPago = false;
        },

        confirmDeletePayment(){
            this.$store.dispatch('deletePayment', this.selectedPayment[0].pagoid);
            this.selectedPayment = [];
            this.bBorrandoPago = false;
        },

        onNuevoServicio(){
            this.selectedServiceIndex = -1;
            this.selectedServiceID = 0;
            this.selectedServiceName = '',
            this.subtotalServicio = 0;
            this.ivaServicio = 0;
            this.bIvaServicio = false;
            this.totalServicio = 0;

            this.bDlgNuevoServicio = true;
        },
        onCancelarNuevoServicio(){
            this.bDlgNuevoServicio = false;
        },
        onConfirmarNuevoServicio(){
            //Se obtiene un ID temporal (negativo) para el nuevo servicio (el definitivo
            //lo asignará el servidor):

            var i;
            var tempID = 1;
            for (i = 0; i < this.event.servicios.length; i ++)
            {
                if (Math.abs(this.event.servicios[i].servicioid) === Math.abs(tempID))
                {
                    tempID = Math.abs(this.event.servicios[i].servicioid) + 1;
                }
            }

            tempID = tempID * -1;

            const serviceToAdd = {
                servicioid: tempID,
                concepto: this.selectedServiceName,
                costo: this.costoServicio,
                cantidad: this.cantidadServicio,
                subtotal: this.subtotalServicio,
                iva: this.ivaServicio,
                total: this.totalServicio 
            }

            this.event.servicios.push(serviceToAdd);

            console.log("servicios adicionales = ", this.event.servicios);

            //Se actualizan los totales:
            //this.event.totalServicios += this.totalServicio;
            //this.event.totalEvento +=  this.totalServicio;
            //this.event.adeudo += this.totalServicio;

            //Se resetean las cantidades del Modal para insertar un servicio adicional:
            this.selectedServiceIndex = -1;
            this.selectedServiceID = 0;
            this.selectedServiceName = '',
            this.costoServicio = 0,
            this.cantidadServicio = 0,
            this.subtotalServicio = 0;
            this.ivaServicio = 0;
            this.bIvaServicio = false;
            this.totalServicio = 0;

            this.bDlgNuevoServicio = false;
        },

        onDeleteService()
        {
            //console.log("selectedService = ", this.selectedService);
            this.servicioABorrrar = this.selectedService[0].concepto;
            this.bBorrandoServicio = true;
        },

        cancelDeleteService()
        {
            this.bBorrandoServicio = false;
        },

        confirmDeleteService()
        {
            var i;
            for (i = 0; i < this.event.servicios.length; i ++)
            {
                if (this.event.servicios[i].servicioid === this.selectedService[0].servicioid)
                {
                    //this.event.totalServicios -= this.selectedService[0].total;
                    //this.event.totalEvento -= this.selectedService[0].total;
                    //this.event.adeudo -= this.selectedService[0].total;
                    this.event.servicios.splice(i, 1);
                    break;
                }
            }

            this.selectedService = [];
            this.bBorrandoServicio = false;
        },

        onSearchServicio() {
            if (this.searchServiceText != '') {
                //Se convierte el texto a minúsculas para hacer la comparación:

                var searchTextLowerCase = this.searchServiceText.toLowerCase();

                var i;
                var bFound = false;
                for (i = 0; i < this.services.length; i++) {
                    var strLowerCaseText = this.services[i].servicio.toLowerCase();
                    if (strLowerCaseText.indexOf(searchTextLowerCase) === 0) {
                        this.selectedServiceIndex = i;
                        this.scroll(this.services[i].servicioid);
                        this.selectService(this.services[i].servicioid);
                        bFound = true;
                        break;
                    }
                }
                if (!bFound) {
                    this.bShowExtraNotFoundAlert = true;
                }
                this.searchServiceText = '';
            }
        },

        scroll(id)
        {
            document.getElementById(id).scrollIntoView({behavior: "smooth"});
        },

        onChangeCostoServicio(){
            this.onCheckIvaServicio();
        },

        onCheckIvaServicio() {
             this.subtotalServicio = this.costoServicio * this.cantidadServicio;
            if (!this.bIvaServicio)
            {
                this.ivaServicio = 0;
            }
            else
            {
                this.ivaServicio = this.costoServicio * this.cantidadServicio * 0.16;
            }
            this.totalServicio = Number(this.subtotalServicio) + Number(this.ivaServicio);
        },

        onChangeSubtotalPago(){
            this.onCheckIvaPago();
        },

        onCheckIvaPago()
        {
            console.log("onCheckIvaPago()");
            if (!this.bIvaPago)
            {
                this.ivaPago = 0;
            }
            else
            {
                this.ivaPago = this.subtotalPago * 0.16;
            }
            this.totalPago = Number(this.subtotalPago) + Number(this.ivaPago);
        },

        calcularCostosPaquete()
        {
            this.event.subtotalPaquete = this.event.costoPersona * this.event.numPersonas;
            if (this.bIvaPaquete)
            {
                this.event.ivaPaquete = this.event.subtotalPaquete * 0.16;
            }
            else
            {
                this.event.ivaPaquete = 0;
            }
            //this.event.totalPaquete = this.event + this.event.subtotalPaquete + this.event.ivaPaquete;

        },

        onChangeCostoPersona(){
            this.calcularCostosPaquete();
        },

        onCheckIvaPaquete() { //Checar esta función
            if (!this.bIvaPaquete)
            {
                this.event.ivaPaquete = 0;
            }
            else
            {
                this.event.ivaPaquete = this.event.subtotalPaquete * 0.16;
            }
            //this.event.totalPaquete = Number(this.event.subtotalPaquete) + Number(this.event.ivaPaquete);
        },

        onChangeNumPersonas(){
            this.calcularCostosPaquete();
        },

    },
    computed: {
        ...mapGetters([
            'waitCursor',
            'userType',
            'loggedUserID',
            'users',
            'eventPackages',
            'eventRooms',
            'services',
            'client' //Cliente seleccionado en el modal para búsqueda de clientes.
        ]),

        totalPaquete() {
            var total = this.event.subtotalPaquete + this.event.ivaPaquete;
            return total;
        },

        totalServicios() {
            var total = 0;
            var i;
            for (i = 0; i < this.event.servicios.length; i ++)
            {
                total += this.event.servicios[i].total;
            }
            return total;
        },

        totalEvento() {
            var total = this.totalPaquete + this.totalServicios;
            return total;
        },

        pagado() {
            var pagado = 0;
            var i;
            for (i = 0; i < this.event.pagos.length; i ++)
            {
                pagado += this.event.pagos[i].total;
            }
            return pagado;
        },

        saldo() {
            var saldo = this.totalEvento - this.pagado;
            return saldo;
        },

        selectedEventIndex: {
            get() {
                return this.$store.getters.selectedEventIndex;
            },
            set(selectedEventIndex) {
                this.$store.dispatch(
                    'updateSelectedEventIndex',
                    selectedEventIndex
                );
            },
        },

        events: {
            get() {
                return this.$store.getters.events;
            },
            set(events) {
                this.$store.dispatch('updateEvents', events);
            },
        },

        event: {
            get() {
                return this.$store.getters.event;
            },
            set(event) {
                this.$store.dispatch('updateEvent', event);
            },
        },

        eventLoaded: {
            get() {
                return this.$store.getters.eventLoaded;
            },
            set(eventLoaded) {
                this.$store.dispatch('updateEventLoaded', eventLoaded);
            },
        },

        loadingEvent: {
            get() {
                return this.$store.getters.loadingEvent;
            },
            set(loadingEvent) {
                this.$store.dispatch('updateLoadingEvent', loadingEvent);
            },
        },

        invoiceProcessed: {
            get() {
                return this.$store.getters.invoiceProcessed;
            },
            set(invoiceProcessed) {
                this.$store.dispatch('updateInvoiceProcessed', invoiceProcessed);
            },
        },

        pdfPath: {
            get() {
                return this.$store.getters.pdfPath;
            },
            set(pdfPath) {
                this.$store.dispatch('updatePdfPath', pdfPath);
            },
        },


        showClientsDlg: {
            get() {
                return this.$store.getters.showClientsDlg;
            },
            set(showClientsDlg){
                this.$store.dispatch('updateShowClientsDlg', showClientsDlg);
            }
        },

        noClientSearchResult: {
            get() {
                return this.$store.getters.noClientSearchResult;
            },
            set(noClientSearchResult){
                this.$store.dispatch('updateNoClientSearchResult', noClientSearchResult);
            }
        },

        listHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '400px';
            } else {
                height = '700px';
            }
            return height;
        },

        errorModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '50%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '40%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '30%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '20%';
            }
            return width;
        },

        clientsModalWidth() {
            var width = '100%';
            if (this.$vuetify.breakpoint.xs) {
                width = '90%';
            } else if (this.$vuetify.breakpoint.sm) {
                width = '80%';
            } else if (this.$vuetify.breakpoint.md) {
                width = '70%';
            } else if (this.$vuetify.breakpoint.lg) {
                width = '60%';
            } else if (this.$vuetify.breakpoint.xl) {
                width = '50%';
            }
            return width;
        },

        logoHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '40';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '50';
            } else if (this.$vuetify.breakpoint.md) {
                height = '65';
            } else if (this.$vuetify.breakpoint.lg) {
                height = '80';
            } else {
                height = '100';
            }
            return height;
        },
    },

    watch: {
        eventLoaded: function (value, oldValue)
        {
            if (this.eventLoaded)
            {
                this.getEventLocalData();
                this.eventLoaded = false;
            }
        },
        client: function (value, oldValue)
        {
            this.event.clienteid = this.client.clienteid;
            this.event.cliente = this.client.nombre;
            this.event.rfc = this.client.rfc;
        },
        invoiceProcessed: function (value, oldValue) {
            if (this.invoiceProcessed) {
                this.invoiceProcessed = false;

                if (this.pdfPath !== '') {
                    window.open(this.pdfPath);
                    this.pdfPath = '';
                }
            }
        },
    }
};
</script>

<style scoped>
.sub-window {
    background: rgba(224, 224, 224, 0.6);
}
.events {
    background: url('../assets/fondo.jpg');
    background-size: cover;
    width: 100%;
    height: 100%;
}

.my-list-title {
    font-size: 15px;
    font-weight: bold;
}
.my-list-subtitle {
    font-size: 13px;
    font-weight: bold;
}
.my-list-header {
    font-size: 11px;
    font-weight: bold;
    background-color: #e0e0e0;
}
.my-list-item {
    min-height: 30px !important;
}


/* ***************Modificaciones para que no se parta el texto en v-card-text y en v-card-title (al parecer es un bug de vuetify):************* */
.v-card__text,
.v-card__title {
    word-break: normal; /* maybe !important  */
}
</style>